<template>
  <div id="wrap">
    <div class="footer-body">
      <div class="footer-one">
        <div class="footer-top">
          <div class="item-mode">
            <div class="right">
              <img src="../assets/img/ficon-ad.png" alt="" />
            </div>
            <div class="left">
              <h4>数字广告</h4>
              <p>ad@chinanola.com</p>
            </div>
          </div>
          <div class="item-mode">
            <div class="right">
              <img src="../assets/img/ficon-con.png" alt="" />
            </div>
            <div class="left">
              <h4>数字内容</h4>
              <p style="letter-spacing: 0px">mcn@chinanola.com</p>
            </div>
          </div>
          <div class="item-mode">
            <div class="right">
              <img src="../assets/img/ficon-ga.png" alt="" />
            </div>
            <div class="left">
              <h4>游戏业务</h4>
              <p>game@chinanola.com</p>
            </div>
          </div>
          <div class="item-mode">
            <div class="right">
              <img src="../assets/img/ficon-hr.png" alt="" />
            </div>
            <div class="left">
              <h4>人力资源</h4>
              <p>hr@chinanola.com</p>
            </div>
          </div>
          <div class="item-mode">
            <div class="right">
              <img src="../assets/img/foot-icon-nu.png" alt="" />
            </div>
            <div class="left">
              <h4>官方电话</h4>
              <p>0591-83052379</p>
            </div>
          </div>
          <div class="item-mode footer-wchat">

            <div class="left">
              <img src="../assets/img/dalv-wchat.jpg" alt="大吕网络微信公众" />
            </div>
            <div class="right">
              <p>官方微信公众号</p>
            </div>
          </div>
        </div>
        <div class="footer-box">
          <div class="footer-href">
            <p class="footer-hd">战略合作伙伴</p>
            <div class="href-wrap">
              <a href="http://www.sbcvc.com/" target="_blank">软银中国</a>
              <a href="https://china.nba.com/" target="_blank">NBA中国</a>
              <a href="http://www.ccmg.cn/" target="_blank">中国文化传媒集团</a>
              <a href="http://www.nd.com.cn/" target="_blank">网龙公司</a>
              <a href="https://www.bytedance.com/" target="_blank">字节跳动</a>
              <a href="https://www.ijunhai.com/index/index.html" target="_blank">君海网络</a>
              <a href="http://www.hep.com.cn/" target="_blank">高等教育出版社</a>
              <a href="http://www.changwankeji.com/" target="_blank">畅玩集团</a>
              <a href="https://www.youzu.com/" target="_blank">游族网络</a>
            </div>
          </div>
          <div class="clo-line"></div>
          <div class="footer-unit">
            <p class="footer-hd">公司地址</p>
            <div class="addr">
              <p>福州总部：仓山区金林路35号互联网小镇1号楼5F</p>
              <p>北京公司：北京海淀区知春路甲48-1号盈都大厦</p>
              <p>厦门公司：厦门市思明区观音山信义国际中心1902</p>
            </div>
          </div>
          <div class="clo-line"></div>
        </div>
      </div>
      <div class="footer-two">
        <div class="footer-props">
          <p>
            <img src="../assets/img/footer-ico-mww.png" alt="闽网文" />
            <a href="https://zwfw.fujian.gov.cn/province-dept/index?type=2&siteUnid=76677B814DDD58185DAC0BFF3017D632&randomNum=0.2308447739068591"
              target="_blank">闽网文〔2017〕6960-136号</a>
          </p>
          <p>
            <img class="footer-icp" src="../assets/img/footer-ico-gicp.png" alt="备案号" />
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010402351311" target="_blank">闽公网安备
              35010402351311号</a>
          </p>
          <br>
          <p style="margin-right:.5rem">
            <img class="footer-icp" src="../assets/img/footer-ico-icp.png" alt="备案号" />
            <a href="https://beian.miit.gov.cn" target="_blank">备案/许可证号 闽ICP备17001152号-2</a>
          </p>
          <p>
            <a href="../assets/img/promise1.png" target="_blank">国家高新技术企业</a>
          </p>

          <br>
          <p style="margin-right: 1.6rem;">
            <a href="http://www.miit.gov.cn/" target="_blank">电信增值业务许可证 闽B2-20180237</a>
          </p>
          <p>
            <a href="http://www.innofund.gov.cn/zxqyfw/c101155/ejlist.shtml" target="_blank">科技型中小企业认证</a>
          </p>
          <br>
          <p>
            <a href="https://mp.weixin.qq.com/s/WOgJBkZoA-707KMj9ItpfQ" target="_blank">科技小巨人企业认证</a>
          </p>
          <br>
          <p>
            <a href="../assets/img/promise.png" target="_blank">中华人民共和国出版物经营许可证</a>
          </p>
          <p>
            <a href="https://www.chinanola.com/img/images_promise1.jpg" target="_blank">广播电视节目制作经营许可证</a>
          </p>
          <br>

          <p style="margin:0">Copyright © 2016-2022 Nola Network Websoft.All Rights Reserved</p>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "appFooter",
};
</script>

<style lang="scss">
//footer底部样式
#wrap {
  width: 100%;
  background: url("../assets/img/footer_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  h4 {
    line-height: 1.5em;
    font-weight: 500;
    letter-spacing: 1px;
    margin-bottom: 0;
    font-size: .8rem;
  }

  p {
    font-size: 0.5rem;
    color: #72768e;
  }

  a {
    color: #72768e !important;
  }

  .footer-body {
    position: relative;
    font-family: "helvetica";
    margin: 0 auto;

    .footer-top {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 30px 0 0 0;

      .item-mode {
        width: 50%;
        padding: 10px 0;

        .left {
          >h4 {
            color: #fff;
            text-align: center;
          }

          >p {
            color: #fff;
            text-align: center;
          }
        }

        .right {
          width: 40px;
          margin: 0 auto;
        }
      }

      .footer-wchat {
        .right {
          width: 100%;

          p {
            height: 30px;
            line-height: 30px;
            color: #fff;
            text-align: center;
          }
        }

        .left {
          width: 60px;
          margin: 0 auto;
        }
      }
    }

    .footer-one {
      padding: 0 15px;

      .footer-box {
        .footer-hd {
          font-size: .8rem;
          line-height: 2em;
          color: #fff;
          margin-bottom: 5px;
        }

        .footer-href {

          // border-right: 1px solid #3A3D4C;
          >.href-wrap {
            display: flex;
            flex-wrap: wrap;

            >a {
              display: block;
              width: 33.3%;
              font-size: 0.6rem;
              line-height: 1em;
              margin-bottom: 10px;
              text-align: center;
            }
          }
        }
      }
    }

    .footer-two {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 20px 15px 15px;

      .footer-copyright {
        color: #9e9e9e;
        line-height: 2em;
      }

      .footer-props {
        &>p {
          display: inline;

          // margin-right: .8rem;
          img {
            width: 15px;

            &.footer-icp {
              width: 13px;
            }
          }

          a {
            font-size: 0.5rem;
            color: #9e9e9e;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue